//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DetailRole",
  data() {
    return {
      accounts: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      ownAuthData: [],
      pagination: {
        currentPage: 1,
        pageSize: 5,
        recordTotal: 0,
      },
    };
  },
  props: {
    dialogRoleDetailVisible: {
      type: Boolean,
      default: () => true,
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
    showList: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 17:17:35
     */
    close() {
      this.$emit("close", "dialogRoleDetailVisible");
    },
    /**
     * @description: 获取权限
     * @Author: yangsibo
     * @Date: 2022-05-25 17:17:53
     */
    async getOwnAuthData() {
      try {
        let { data } = await this.$http.common.selectOwnSMenuTree({
          roleIdList: [this.curRoleDetail.id],
        });
        this.ownAuthData = data;
      } catch (error) {}
    },
    /**
     * @description: 获取成员列表
     * @Author: yangsibo
     * @Date: 2022-05-25 17:18:57
     */
    async getAccounts() {
      this.$http.account
        .getManageAccount({
          ...this.pagination,
          roleId: this.curRoleDetail.id,
          systemType: this.systemType,
        })
        .then((res) => {
          let { recordTotal, content: accounts } = res.data;
          this.pagination.recordTotal = recordTotal;
          this.accounts = accounts;
        });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAccounts();
    },
  },
  created() {},
  mounted() {
    this.getOwnAuthData();
    this.getAccounts();
  },
};
